import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import queryString from 'query-string';
import { fromJS, List } from 'immutable';

import {
  isFilterSet,
  getFilterHash,
  getFilterFromQS,
} from 'redux/modules/browse';

import Button from 'react-bootstrap/lib/Button';

import browseStyles from 'containers/Browse/Browse.module.scss';
import styles from './BrowsePagination.module.scss';

@withRouter
@connect(
  (state) => ({
    filterResults: fromJS(state.browse.filterResults),
    filteredUserEntities: fromJS(state.entities.filteredUsers),

    ownBriefs: state.auth.ownBriefs,
    briefEntities: state.entities.briefs,
  }),
  {}
)
class BrowsePagination extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: Number(props.location.query.page) || 1,
    };
  }

  componentDidUpdate(prevProps) {
    const oldQuery = queryString.parse(prevProps.location.search);
    const newQuery = queryString.parse(this.props.location.search);

    if (oldQuery.page) {
      // `?page` changed
      if (newQuery.page && oldQuery.page !== newQuery.page) {
        this.loadPage(newQuery.page, false);
      }

      // `?page` got deleted from the QS
      if (newQuery.page === undefined) {
        this.loadPage(1, false);
      }
    }
  }

  handleSearch = (page) => {
    const { history, location } = this.props;

    const currentQuery = queryString.parse(location.search);
    const newQuery = {
      ...currentQuery,
    };

    newQuery.page = page;

    Object.keys(newQuery).forEach(
      (key) => !newQuery[key] && delete newQuery[key]
    );

    history.replace(
      queryString.stringifyUrl({
        url: '/browse',
        query: isFilterSet(newQuery) ? newQuery : {},
      })
    );

    // Determine `offsetTop` of `.browseContainer`
    const elements = document.getElementsByClassName(
      browseStyles.browseContainer
    );
    const browseContainer = elements && elements.length > 0 && elements[0];

    window.scrollTo({
      top: browseContainer.offsetTop - 5,
      // behavior: 'smooth',
    });
  };

  loadPage = (page, fetchResults = true) => {
    this.setState(
      {
        page: Number(page) || 1,
      },
      () => {
        if (fetchResults) {
          this.handleSearch(this.state.page);
        }
      }
    );
  };

  render() {
    const { page } = this.state;

    // Filter & hash
    const { location } = this.props;
    const filter = getFilterFromQS(location);
    const hash = getFilterHash(filter);

    // Redux store
    const { filterResults } = this.props;
    const totalPages = filterResults.getIn([hash, 'totalPages'], 0);

    // Render conditionals
    const isLoading = filterResults.getIn([hash, 'loading'], false);
    const isEmptyResults =
      filterResults.getIn([hash, 'results'], List()).size === 0;
    const isMultiplePages = totalPages >= 2;

    return (
      isFilterSet(filter) &&
      !isLoading &&
      !isEmptyResults &&
      isMultiplePages && (
        <div className={styles.container}>
          <Button
            disabled={Number(page) <= 1}
            className={styles.pageChangeButton}
            onClick={(e) => {
              e.preventDefault();
              this.loadPage(page - 1);
            }}
          >
            Prev
          </Button>

          <div className={styles.pageDisplayContainer}>
            <span className={styles.pageDisplayNumber}>{page.toString()}</span>
            {` / `}
            <span className={styles.pageDisplayNumber}>
              {totalPages.toString()}
            </span>
          </div>

          <Button
            className={styles.pageChangeButton}
            disabled={Number(page) === Number(totalPages)}
            onClick={(e) => {
              e.preventDefault();
              this.loadPage(page + 1);
            }}
          >
            Next
          </Button>
        </div>
      )
    );
  }
}

BrowsePagination.propTypes = {
  location: PropTypes.object,

  filterResults: PropTypes.any,
};

export default BrowsePagination;
